import { MediaMatcher } from '@angular/cdk/layout';
import { Component, ChangeDetectorRef, OnDestroy, DoCheck, ViewChild, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlertPopComponent } from './components/alert-pop/alert-pop.component';
import { UserPopComponent } from './components/user-pop/user-pop.component';
import { GLOBAL } from './services/global';
import {UserService} from './services/user.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy, DoCheck{
  mobileQuery: MediaQueryList;
  private mobileQueryListener: () => void;
  title = 'SIAREG';
  public sessionActive: boolean;
  public identity;
  public rndmKey: string;
  public url: string;
  @HostListener('window:keydown', ['$event'])
  KeyDown(event: KeyboardEvent) {
    if(!this.isSuperUserAttempt){
      if (event.ctrlKey ) {
        if (event.keyCode == 106 || event.keyCode == 91) {
            this.isSuperUserAttempt = true;
            return;
        }
     }
    }else{
      if (event.ctrlKey) {
        if (event.keyCode == 111 || event.altKey) {
            this.isSuperUserAttempt = false;
            this.userPop();
            return;
        }
     }
    }
  }

  public isSuperUserAttempt: boolean = false;

  constructor(
    public dialog: MatDialog,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
    private userService: UserService,
  ){
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    this.identity = this.userService.getIdentity();
    this.rndmKey = this.userService.generateRandomString(10);
    localStorage.setItem('avatar_random', this.rndmKey);
    this.url = GLOBAL.url;

    this.sessionActive = false;


    if (this.userService.getToken()) {
      this.sessionActive = true;
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this.mobileQueryListener);
  }


  userPop(): void {
    const dialogRef = this.dialog.open(UserPopComponent, {
      width: '40%',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  ngDoCheck(): void{
    if (this.userService.getToken()) {
      this.sessionActive = true;
    } else {
      this.sessionActive = false;
    }

    this.identity = this.userService.getIdentity();
    this.rndmKey = this.userService.getRandom();

  }

  closeSession() {
    this.userService.destroy_session();
    this.router.navigate(['/login']);
  }

}
